module.exports = __webpack_public_path__ + "static/media/eth-icon.126c2af5.svg";